export class CanPayByInvoiceType {
    static YES = 'yes';
    static NO_BY_ADMIN = "no_by_admin";
}

Object.freeze(CanPayByInvoiceType);